import { InputNumber } from 'element-ui'

const YInputNumber = InputNumber
YInputNumber.$depends = [InputNumber]
YInputNumber.$name = 'y-input-number'
YInputNumber._name = 'InputNumber 计数器'

export default YInputNumber
